export default "__VITE_PUBLIC_ASSET__feda2ebc__"